import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import FlaggedUsersTable from 'components/tables/FlaggedUsersTable/FlaggedUsersTable';
import useGlobalStyles from 'styles/globalStyles';


// Accounts refused for opening too many products - who may be copying the
// catalogue - with the same suspend buttons as All Users.
export default function FlaggedUsersPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'Flagged'}
            buttons={[
              // <CustomButton key='export' text='Export' color='primary' />
            ]}
          />
        </Box>

        <Box mt={3}>
          <FlaggedUsersTable />
        </Box>
      </Container>
    </Box>
  )
}

